export enum ValidationStates {
    Valid,
    InvalidFormat,
    MissingRequired,
    EmailExists,
}
